import { FC, useMemo } from 'react'
import CommonLayout from 'components/layouts/CommonLayout'
import CardLayout from 'components/layouts/CardLayout'
import { PasswordResetForm } from 'components/features/pfm/PasswordReset/PasswordResetForm'
import { PasswordCodeSendForm } from 'components/features/pfm/PasswordReset/PasswordCodeSendForm'
import { onFormSubmit } from 'helpers/formHelpers'
import styles from 'components/features/pfm/PasswordReset/PasswordReset.styl'
import { useStoreSelector, useShallowSelector } from 'helpers/reactReduxHelpers'
import { formValueSelector } from 'redux-form'
import { FORM_PASSWORD_CODE_SEND, FORM_LOGIN } from 'constants/forms'

const codeFormSelector = formValueSelector(FORM_PASSWORD_CODE_SEND)
const loginFormSelector = formValueSelector(FORM_LOGIN)

export const PasswordReset: FC = () => {
  const { resetCodeSent } = useShallowSelector((state) => state.app.auth)

  const passwordResetEmail = useStoreSelector((state) => codeFormSelector(state, 'email') as string)
  const passwordResetInitialValues = useMemo(() => ({
    email: passwordResetEmail,
  }), [passwordResetEmail])

  const codeEmail = useStoreSelector((state) => loginFormSelector(state, 'email') as string)
  const passwordCodeSendInitialValues = useMemo(() => ({
    email: codeEmail,
  }), [codeEmail])

  const formChild = useMemo(() => {
    if (resetCodeSent) {
      return (
        <PasswordResetForm
          onSubmit={ onFormSubmit }
          initialValues={ passwordResetInitialValues }
        />
      )
    }

    return (
      <PasswordCodeSendForm
        onSubmit={ onFormSubmit }
        initialValues={ passwordCodeSendInitialValues }
      />
    )
  }, [passwordCodeSendInitialValues, passwordResetInitialValues, resetCodeSent])

  return (
    <CommonLayout>
      <CardLayout title='Reset Your Password'>
        <div className={ styles.form }>
          { formChild }
        </div>
      </CardLayout>
    </CommonLayout>
  )
}
